import { requestJson } from "./instateamAdminApi";

export function getAdminReportsOverview(token, params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value && value !== "all") searchParams.set(key, value);
  });
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return requestJson(`/instateam/performance/admin/reports${suffix}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getAdminEmployeePerformanceOverview(token, employeeId, params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return requestJson(`/instateam/performance/admin/employees/${employeeId}/overview${suffix}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
